document.addEventListener('DOMContentLoaded', function () {
  if (document.getElementById('calendar')) {
    const calendarEl = document.getElementById('calendar');

    const calendar = new FullCalendar.Calendar(calendarEl, {
      initialView: 'timeGridWeek',
      nowIndicator: true,
      weekends: true,
      firstDay: 1,
      expandRows: true,
      allDaySlot: true,
      slotDuration: '01:00:00',
      scrollTime: '06:00:00',
      allDayText: 'Out of office',
      height: '100%',
      slotLabelFormat: {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
      },
      eventTimeFormat: {
        hour: 'numeric',
        minute: '2-digit',
        meridiem: false,
      },
      dayHeaderContent: function (arg) {
        const day = arg.date.getDate();
        const weekday = arg.date.toLocaleDateString('en-US', { weekday: 'short' });
        return { html: `<span class="fc-daywrap"><span class="fc-daywrap__date">${day}</span>${weekday}</span>` };
      },
      headerToolbar: false,
      events: function (fetchInfo, successCallback, failureCallback) {
        const url = new URL(window.CALENDAR_EVENTS_URL, window.location.origin);

        // Use the calendar's visible date range
        url.searchParams.set('start', fetchInfo.startStr);
        url.searchParams.set('end', fetchInfo.endStr);

        // Read current page URL params
        const pageParams = new URLSearchParams(window.location.search);

        // Lecturers array
        const lecturersParam = 'overview_filter_form[lecturers][]';
        pageParams.getAll(lecturersParam).forEach((id) => {
          url.searchParams.append('lecturers[]', id);
        });

        // Fetch events from Symfony
        fetch(url)
          .then((res) => {
            return res.json();
          })
          .then((events) => {
            successCallback(events);
          })
          .catch((err) => {
            failureCallback(err);
          });
      },
      initialDate: window.calendarSelectedDay,
      dateClick: function (info) {
        var clickedDateTime = info.date;
        var timeParam = clickedDateTime.toISOString();

        window.location.href = '/cs/delivery?time=' + encodeURIComponent(timeParam);
      },
      eventClick: function (info) {
        if (!info.event.allDay) {
          fetch('/get-sidebar-data/' + info.event.id)
            .then((response) => {
              if (!response.ok) {
                throw new Error('Failed to load sidebar data');
              }
              return response.text();
            })
            .then((html) => {
              sidebar = document.querySelector('.sidebar').innerHTML = html;

              document.querySelector('.sidebar').classList.add('is-open');
              document.querySelector('.sidebar-container').classList.add('is-active');

              document.querySelector('.js-close-sidebar').addEventListener('click', () => {
                document.querySelector('.sidebar').classList.remove('is-open');
                document.querySelector('.sidebar-container').classList.remove('is-active');
              });

              const sidebarBody = document.querySelector('.sidebar__body');
              if (document.querySelector('.sidebar__body')) {
                new SimpleBar(sidebarBody, {
                  autoHide: true,
                });
              }
            })
            .catch((error) => {
              console.error(error);
            });
        }
      },
    });

    calendar.render();
  }
});
